import { ExtensionsDocumentation } from "./extensions/extensions";
import Spinner from "../common/Spinner";
import { useDocumentation } from "./documentation-hooks";

const ApiArea = () => {
  const { extensions } = useDocumentation(); 
  return extensions ? <ExtensionsDocumentation extensions={extensions} /> : <Spinner />;
};

export default ApiArea;